import React from "react";
import { Link } from "react-router-dom";
import logo from "../imgs/logo.png";

const TermsConditions = () => {
  return (
    <div className="legal-page">
      {/* Navigation Header */}
      <div className="legal-nav">
        <div className="legal-nav-container">
          <Link to="/" className="back-button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
            </svg>
            Back
          </Link>

          <div className="legal-nav-brand">
            <img src={logo} alt="Viralz Logo" className="legal-nav-logo" />
            <span className="legal-nav-title">Viralz</span>
          </div>
        </div>
      </div>

      <div className="legal-container">
        <h1>Terms of Service</h1>
        <div className="legal-meta">
          <p>
            <strong>Effective Date:</strong> January 1, 2025
          </p>
          <p>
            <strong>Last Updated:</strong> January 1, 2025
          </p>
        </div>

        <section>
          <h2>1. ACCEPTANCE OF TERMS</h2>
          <p>
            By accessing or using Viralz ("Service"), you agree to be bound by
            these Terms of Service ("Terms"). If you disagree with any part of
            these terms, you may not access the Service.
          </p>
        </section>

        <section>
          <h2>2. DESCRIPTION OF SERVICE</h2>
          <p>
            Viralz is a TikTok analytics and content optimization platform that
            provides:
          </p>
          <ul>
            <li>
              <strong>Profile Analysis:</strong> Comprehensive analysis of
              TikTok profiles and content
            </li>
            <li>
              <strong>AI Insights:</strong> Artificial intelligence-powered
              content recommendations
            </li>
            <li>
              <strong>Performance Tracking:</strong> Real-time monitoring of
              engagement and growth metrics
            </li>
            <li>
              <strong>Content Tools:</strong> Idea generation and optimization
              suggestions
            </li>
            <li>
              <strong>Premium Features:</strong> Advanced analytics and insights
              (subscription required)
            </li>
          </ul>
        </section>

        <section>
          <h2>3. USER ACCOUNTS</h2>

          <h3>3.1 Account Creation</h3>
          <ul>
            <li>
              You must provide accurate and complete information when creating
              an account
            </li>
            <li>
              You are responsible for maintaining the security of your account
              credentials
            </li>
            <li>You must be at least 13 years old to use the Service</li>
          </ul>

          <h3>3.2 Account Responsibilities</h3>
          <ul>
            <li>
              You are responsible for all activities that occur under your
              account
            </li>
            <li>
              You must notify us immediately of any unauthorized use of your
              account
            </li>
            <li>You may not share your account credentials with others</li>
          </ul>
        </section>

        <section>
          <h2>4. ACCEPTABLE USE</h2>

          <h3>4.1 Permitted Use</h3>
          <ul>
            <li>
              Use the Service for personal or business purposes related to
              TikTok content creation
            </li>
            <li>Analyze your own TikTok profiles and content</li>
            <li>
              Access insights and recommendations provided by our AI systems
            </li>
          </ul>

          <h3>4.2 Prohibited Use</h3>
          <ul>
            <li>Use the Service for any illegal or unauthorized purpose</li>
            <li>Violate any laws in your jurisdiction</li>
            <li>Transmit any harmful, offensive, or inappropriate content</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Reverse engineer or attempt to extract source code</li>
            <li>Use the Service to harass, abuse, or harm others</li>
            <li>Impersonate any person or entity</li>
          </ul>
        </section>

        <section>
          <h2>5. SUBSCRIPTION SERVICES</h2>

          <h3>5.1 Premium Features</h3>
          <ul>
            <li>Certain features require a paid subscription</li>
            <li>
              Subscription fees are charged in advance on a recurring basis
            </li>
            <li>Prices are subject to change with notice</li>
          </ul>

          <h3>5.2 Payment Terms</h3>
          <ul>
            <li>
              Payments are processed through Apple App Store or Google Play
              Store
            </li>
            <li>Subscriptions automatically renew unless cancelled</li>
            <li>
              Refunds are subject to the policies of the respective app stores
            </li>
          </ul>

          <h3>5.3 Cancellation</h3>
          <ul>
            <li>
              You may cancel your subscription at any time through your app
              store account
            </li>
            <li>
              Cancellation takes effect at the end of the current billing period
            </li>
            <li>No refunds for partial periods</li>
          </ul>
        </section>

        <section>
          <h2>6. INTELLECTUAL PROPERTY</h2>

          <h3>6.1 Our Rights</h3>
          <ul>
            <li>The Service and its original content are owned by Viralz</li>
            <li>Our trademarks, logos, and service marks are protected</li>
            <li>
              You may not use our intellectual property without permission
            </li>
          </ul>

          <h3>6.2 Your Content</h3>
          <ul>
            <li>You retain ownership of your TikTok content and data</li>
            <li>
              You grant us a license to use your data to provide the Service
            </li>
            <li>
              We may use aggregated, anonymized data for service improvement
            </li>
          </ul>
        </section>

        <section>
          <h2>7. PRIVACY</h2>
          <p>
            Your privacy is important to us. Please review our Privacy Policy,
            which governs how we collect, use, and disclose your information.
          </p>
        </section>

        <section>
          <h2>8. DISCLAIMERS</h2>

          <h3>8.1 Service Availability</h3>
          <ul>
            <li>The Service is provided "as is" without warranties</li>
            <li>We do not guarantee uninterrupted or error-free service</li>
            <li>We may modify or discontinue features at any time</li>
          </ul>

          <h3>8.2 Third-Party Data</h3>
          <ul>
            <li>TikTok data is provided by third-party APIs</li>
            <li>We are not responsible for the accuracy of third-party data</li>
            <li>TikTok may change their policies affecting our Service</li>
          </ul>
        </section>

        <section>
          <h2>9. LIMITATION OF LIABILITY</h2>
          <p>
            To the maximum extent permitted by law, Viralz shall not be liable
            for any indirect, incidental, special, consequential, or punitive
            damages arising from your use of the Service.
          </p>
        </section>

        <section>
          <h2>10. INDEMNIFICATION</h2>
          <p>
            You agree to indemnify and hold harmless Viralz from any claims,
            damages, or expenses arising from your use of the Service or
            violation of these Terms.
          </p>
        </section>

        <section>
          <h2>11. TERMINATION</h2>

          <h3>11.1 Termination by You</h3>
          <ul>
            <li>You may terminate your account at any time</li>
            <li>
              Termination does not relieve you of any obligations incurred prior
              to termination
            </li>
          </ul>

          <h3>11.2 Termination by Us</h3>
          <ul>
            <li>We may terminate your account for violation of these Terms</li>
            <li>
              We may suspend or terminate the Service at any time with notice
            </li>
          </ul>
        </section>

        <section>
          <h2>12. GOVERNING LAW</h2>
          <p>
            These Terms are governed by and construed in accordance with
            applicable laws, without regard to conflict of law principles.
          </p>
        </section>

        <section>
          <h2>13. CHANGES TO TERMS</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will
            notify you of any changes by posting the new Terms on this page.
          </p>
        </section>

        <section>
          <h2>14. CONTACT INFORMATION</h2>
          <p>For questions about these Terms, please contact us:</p>
          <ul>
            <li>
              <strong>Email:</strong> viralzmanagement@gmail.com
            </li>
            <li>
              <strong>Website:</strong> https://viralzapp.com/terms
            </li>
          </ul>
        </section>
      </div>

      <style jsx>{`
        .legal-page {
          min-height: 100vh;
          background: #000000;
          color: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif;
          padding: 0;
        }

        .legal-nav {
          background: rgba(0, 0, 0, 0.95);
          backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(254, 44, 85, 0.2);
          padding: 20px 0;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .legal-nav-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .back-button {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #ffffff;
          text-decoration: none;
          font-weight: 600;
          font-size: 1rem;
          padding: 10px 16px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
        }

        .back-button:hover {
          background: rgba(254, 44, 85, 0.2);
          border-color: #fe2c55;
          color: #fe2c55;
          transform: translateX(-2px);
        }

        .legal-nav-brand {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .legal-nav-logo {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: rgba(254, 44, 85, 0.1);
          padding: 4px;
          border: 1px solid rgba(254, 44, 85, 0.3);
        }

        .legal-nav-title {
          font-size: 1.5rem;
          font-weight: 800;
          color: #fe2c55;
        }

        .legal-container {
          max-width: 800px;
          margin: 0 auto;
          line-height: 1.6;
          padding: 40px 20px;
        }

        h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 20px;
          background: linear-gradient(135deg, #fe2c55, #ff6b9d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .legal-meta {
          margin-bottom: 40px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
          border: 1px solid rgba(254, 44, 85, 0.2);
        }

        .legal-meta p {
          margin: 5px 0;
          color: #cccccc;
        }

        section {
          margin-bottom: 40px;
        }

        h2 {
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 20px;
          color: #fe2c55;
        }

        h3 {
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #ffffff;
        }

        p {
          margin-bottom: 15px;
          color: #cccccc;
        }

        ul {
          margin-bottom: 20px;
          padding-left: 20px;
        }

        li {
          margin-bottom: 10px;
          color: #cccccc;
        }

        strong {
          color: #ffffff;
        }

        @media (max-width: 768px) {
          .legal-container {
            padding: 20px 15px;
          }

          .legal-nav-container {
            padding: 0 15px;
          }

          .legal-nav-title {
            font-size: 1.3rem;
          }

          .legal-nav-logo {
            width: 28px;
            height: 28px;
          }

          .back-button {
            padding: 8px 12px;
            font-size: 0.9rem;
          }

          h1 {
            font-size: 2rem;
          }

          h2 {
            font-size: 1.5rem;
          }

          h3 {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TermsConditions;
